/*@flow*/
import GetDataPanels from './GetDataPanels';
import GetDataPanel from './GetDataPanel';

const queries = {
  dataPanels: {
    destroy({ bbox }: { bbox: string }): Array<{|query: $FlowFixMe, variables: {|bbox: string|}|}> {
      return [
        {
          query: GetDataPanels,
          variables: { bbox },
        },
      ];
    },
    edit(props: { id: ?ID, bbox: string }):
  | Array<any>
  | Array<

      | {|query: $FlowFixMe, variables: {|bbox: string|}|}
      | {|query: $FlowFixMe, variables: {|id: number | string|}|},
  > {
      const { id, bbox } = props;
      if (!id) return [];
      let q = [
        {
          query: GetDataPanel,
          variables: { id },
        },
        {
          query: GetDataPanels,
          variables: { bbox },
        },
      ];
      return q;
    },
    new(props: { bbox: string }): Array<{|query: $FlowFixMe, variables: {|bbox: string|}|}> {
      const { bbox } = props;
      let q = [
        {
          query: GetDataPanels,
          variables: { bbox },
        },
      ];

      return q;
    },
  },
};
export default queries;
